"use strict";

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyWorkflowCompileResult = exports.promoteCompileResult = void 0;

function promoteCompileResult(result) {
  var compilations = result.compilations;
  var contracts = compilations.flatMap(function (compilation) {
    return compilation.contracts;
  });
  return {
    compilations: compilations,
    contracts: contracts
  };
}

exports.promoteCompileResult = promoteCompileResult;

function emptyWorkflowCompileResult() {
  return {
    compilations: [],
    contracts: []
  };
}

exports.emptyWorkflowCompileResult = emptyWorkflowCompileResult;